import { render, staticRenderFns } from "./uploadImg.vue?vue&type=template&id=09c7c509&scoped=true"
import script from "./uploadImg.vue?vue&type=script&lang=js"
export * from "./uploadImg.vue?vue&type=script&lang=js"
import style0 from "./uploadImg.vue?vue&type=style&index=0&id=09c7c509&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c7c509",
  null
  
)

export default component.exports